export default "__VITE_ASSET__D7I$7qpB__"